<!--  预约到店 -->
<template>
    <div class="box">
        <div class="tab-box">
            <div v-if="postId != '1472787652026766338' && postId != 3 && postId != '1472787652026765362'" class="title-tab-box">
                <van-tabs animated v-model="activeName" @change="clickTypeTab">
                    <van-tab title="看门店" name="store"> </van-tab>
                    <van-tab title="看我的" name="mine"> </van-tab>
                </van-tabs>
            </div>
            <div class="search">
                <form action="/">
                    <van-search class="search-button" v-model="name" @search="onSearch" @clear="selClear" placeholder="搜索姓名/手机" left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                    </van-search>
                </form>
            </div>
            <div class="date-box  flex-row  flex-between">
                <div class="date">
                    <div class="arrow-box">
                        <div class="arrow-l" @click="handleCalendar('prev')"></div>
                    </div>
                    <div>{{ year }}年{{ month }}月</div>
                    <div class="arrow-box">
                        <div class="arrow-r" @click="handleCalendar('next')"></div>
                    </div>
                </div>
                <div class="change-box" v-if="checkTypeTab == 0 && (postId == 1 || postId == 4 || postId == '1472787652026765367' || postId == '1472787652026765368')">
                    <van-dropdown-menu active-color="#37DBE0">
                        <van-dropdown-item v-model="employeeName" :options="employeeNameList"></van-dropdown-item>
                    </van-dropdown-menu>
                </div>

            </div>
        </div>
        <div class="table">
            <div class="table-tab flex flex-x-center flex-between ">
                <div :class="`tab-item ${tabIndex == 0 ? 'active' : ''}`" @click="clickTab(0)">
                    预约未来店({{ bookingNumList.notArriveSum }})
                </div>
                <div :class="`tab-item  item-text ${tabIndex == 1 ? 'active' : ''}`" @click="clickTab(1)">
                    预约已来店({{ bookingNumList.arriveSum }})
                </div>
            </div>
            <div class="box-line"></div>
            <div class="table-list">
                <div class="tr-head bg-w">
                    <div class="th">姓名&手机</div>
                    <div class="th">所属顾问</div>
                    <div class="th">预约美疗师</div>
                    <div class="th">预约时间</div>
                </div>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                    <div class="data-list" v-if="bookingData.length > 0">
                        <!-- 下拉刷新 -->
                        <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getBookingData(year, month)" :offset="20" :immediate-check="false">
                            <div v-for="(item, index) in bookingData" :key="index">
                                <div class="tr line" @click="toDetail(item.custId, item.custMobile)">
                                    <div class="td">
                                        <div class="td-item">{{ item.custName }}</div>
                                        <div>{{ item.custMobile }}</div>
                                    </div>
                                    <div class="td">
                                        <div>{{ item.empName }}</div>
                                    </div>
                                    <div class="td">
                                        <div>{{ item.name }}</div>
                                    </div>
                                    <div class="td">
                                        <div class="td-item">{{ item.beginTime }}</div>
                                    </div>
                                </div>

                            </div>
                        </van-list>
                    </div>
                    <div class="data-list" v-else style="margin:80px auto">
                        <van-empty image="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" description="暂无数据" />
                    </div>
                </van-pull-refresh>

            </div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { getCookie } from '@/utils'
    import { Toast } from 'vant'

    export default {
        name: "bookingToStore",
        data() {
            return {
                tabIndex: 0, // tab栏下标
                bookingData: [
                    // table数据

                ],
                employeeNameList: [
                ],
                employeeName: "",
                activeName: "store", //tab
                tableData: [],
                tableHeader: [],
                year: "",
                month: "",
                name: "",
                bookingNumList: [],
                checkTypeTab: 0,
                postId: 0,
                loading: false,
                finished: false,
                refreshing: false,
                page: 1,
                total: 0,
            };
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.getemployeesList();
            this.initdateData();
        },
        watch: {
            employeeName(value) {
                this.$nextTick(() => {
                    this.page = 1;
                    this.getBookingData(this.year, this.month);
                    this.getbookingNumList();
                })
            }
        },
        methods: {
            // 初始化时间
            initdateData() {
                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                this.year = year
                this.month = month
            },
            //跳转顾客详情页
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },
            // 获取到店列表的数据
            getBookingData(year, month) {
                this.loading = true
                request({
                    url: "/my/booking/getList?date=" +
                        year +
                        "-" +
                        month +
                        "&type=" +
                        this.tabIndex + "&name=" + this.name + "&empId=" + this.employeeName + "&limit=10&page=" + this.page,
                    method: "get",
                })
                    .then((res) => {
                        this.bookingData = this.page == 1 ? res.data.list : this.bookingData.concat(res.data.list);
                        this.page += 1;
                        this.total = res.data.total;
                    }).catch((error) => {
                        this.finished = true
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                        this.loading = false;
                        this.finished = false;
                        if (this.bookingData.length >= this.total) {
                            this.finished = true;
                        }
                    });
            },
            // 切换月份
            handleCalendar(handle) {
                this.page = 1;
                const year = this.year;
                const month = this.month;
                this.bookingData = [];
                if (handle === "prev") {
                    let newMonth = month - 1;
                    let newYear = year;
                    if (newMonth < 1) {
                        newYear = year - 1;
                        newMonth = 12;
                    }
                    this.getBookingData(newYear, newMonth);
                    this.year = newYear
                    this.month = newMonth
                } else {
                    let newMonth = month + 1;
                    let newYear = year;
                    if (newMonth > 12) {
                        newYear = year + 1;
                        newMonth = 1;
                    }
                    this.getBookingData(newYear, newMonth);

                    this.year = newYear
                    this.month = newMonth
                }
                this.getbookingNumList();
            },
            // tab切换
            clickTab(tabIndex) {
                this.tabIndex = tabIndex
                this.onRefresh();
            },

            //查看类型切换
            clickTypeTab() {
                if (this.activeName == "store") {
                    this.checkTypeTab = 0;
                }
                else {
                    this.checkTypeTab = 1;
                }
                this.getemployeesList();
            },

            // 查询
            onSearch(e) {
                this.name = e
                this.getbookingNumList();
                this.onRefresh();
            },

            //清除搜索
            selClear() {
                this.name = "";
                this.onRefresh();
            },

            // 获取员工信息
            getemployeesList() {
                request({
                    url: `/my/storeEmpBooking`,
                    method: "get",
                    params: { type: this.checkTypeTab }
                })
                    .then((res) => {
                        this.employeeNameList = [];
                        if (res.data.length) {
                            if (this.checkTypeTab == 0) {
                                var allIds = "";
                                res.data.map(n => {
                                    allIds = n.id + ',' + allIds;
                                    this.employeeNameList.push({ text: n.name, value: n.id })
                                })
                                this.employeeName = allIds.slice(0, allIds.length - 1);
                                let newlist = { text: "全部", value: this.employeeName };
                                this.employeeNameList.unshift(newlist); //unshift()在数组头部添加一条数据
                            }
                            else {
                                this.employeeNameList.push({ text: res.data[0].name, value: res.data[0].id })
                                this.employeeName = res.data[0].id;
                            }
                        }
                    })
                    .catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                    })
            },
            // 获取我的预约数量
            getbookingNumList() {
                request({
                    url: `/my/booking/quantity`,
                    method: "get",
                    params: { date: this.year + '-' + this.month, empId: this.employeeName, name: this.name }
                })
                    .then((res) => {
                        this.bookingNumList = res.data
                    })
                    .catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                    })
            },
            onRefresh() {
                this.page = 1
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.bookingData = [];
                this.refreshing = false;
                this.getBookingData(this.year, this.month);
            },
        },
    };
</script>

<style scoped lang="less">
    .box {
        height: 100%;
        // overflow-y: auto;
    }

    .tab-box {
        width: 750px;
        // height: 314px;
        background: #f5f6f7;
    }

    .data-list {
        height: 80vh;
        overflow-y: auto;
    }

    .title-tab-box {
        padding: 30px 30px 0 30px;

        :deep(.van-tabs__line) {
            display: none;
        }

        :deep(.van-tab) {
            /* flex: none !important; */
            /* flex:0 0 25%!important; */
            width: 190px;
            padding: 0 !important;
            height: 70px !important;
            line-height: 70px !important;
            color: #a0acb5;
            font-size: 30px;
        }

        :deep(.van-tab.van-tab--active) {
            /* width: 184rpx !important; */
            height: 70px !important;
            line-height: 70px;
            background: #2fd0d5 !important;
            border-radius: 35px !important;
            color: #fff !important;
        }
    }

    .date {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        line-height: 92.4px;
        margin: -6px 41px;
        font-size: 30px;
        color: #35434c;
    }

    .arrow-l {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-right: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-right: 30px;
    }

    .arrow-r {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-left: 10px solid #35434c;
        border-bottom: 10px solid transparent;
        margin-left: 30px;
    }

    .change-box {
        height: 80px;
        width: 200px;
    }

    .table-tab {
        width: 100%;
        height: 100%;
        display: flex;
        margin: 30px 0 0 0;
    }

    .tab-item {
        width: 250px;
        height: 42px;
        font-size: 30px;
        font-weight: 400;
        color: #a0acb5;
        text-align: center;
        position: relative;
    }

    .item-text {
        margin-left: 102px;
    }

    .tab-item.active {
        color: #35434c;
        font-weight: bold;
    }

    .tab-item.active::after {
        position: absolute;
        bottom: -20px;
        width: 110px;
        content: "";
        height: 4px;
        background: #37dbe0;
        left: 50%;
        transform: translateX(-50%);
    }

    .box-line {
        width: 690px;
        height: 1px;
        background: #d7d7d7;
        margin: 20px 0 0 30px;
        opacity: 0.5;
    }

    .table-list {
        border: 0px solid darkgray;
        padding: 30px;
        height: 100%;
    }

    .tr-head {
        display: flex;
        width: 100%;
        justify-content: center;
        height: 80px;
        align-items: center;
    }

    .tr {
        display: flex;
        width: 100%;
        justify-content: center;
        height: 80px;
        align-items: center;
        border-bottom: 1px solid rgba(215, 215, 215, 0.5);
    }

    .td {
        width: 40%;
        justify-content: center;
        text-align: center;
        font-size: 28px;
        color: #35434c;
    }

    .td-item {
        margin-bottom: 17px;
    }

    .line {
        height: 133px;
    }

    .th {
        width: 40%;
        justify-content: center;
        background: #fafafe;
        color: #66757f;
        display: flex;
        height: 80px;
        align-items: center;
        font-size: 26px;
    }

    .mark {
        width: 98px;
        height: 30px;
        background: #d3f3f4;
        border-radius: 14px;
        margin: 0 auto;
        color: #37dbe0;
        font-size: 18px;
    }

    .van-pull-refresh {
        min-height: 100%;
    }

    :deep(.van-dropdown-menu__bar) {
        background-color: #f5f6f7 !important;
        height: 80px !important;
        box-shadow: none !important;
    }

    :deep(.van-dropdown-menu__title) {
        color: #35434c !important;
        font-size: 30px !important;
    }

    :deep(.van-dropdown-menu__title::after) {
        border-color: transparent transparent #35434c #35434c !important;
        border-top-width: 7px !important;
        border-right-width: 7px !important;
        border-bottom-width: 7px !important;
        border-left-width: 7px !important;
        border-top-style: solid !important;
        border-right-style: solid !important;
        border-bottom-style: solid !important;
        border-left-style: solid !important;
    }

    :deep(.van-search) {
        background-color: #f5f6f7 !important;
        padding: 15px 30px !important;
    }

    :deep(.van-search .van-cell) {
        background-color: #ffffff !important;
    }

    :deep(.van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 10px 20px 0 20px !important;
        margin-right: 0 !important;
    }

    :deep(.van-tabs__nav) {
        background-color: #f5f6f7 !important;
    }

    :deep(.van-list__finished-text) {
        height: 280px !important;
    }

    :deep(.van-icon) {
        font-size: 28px;
    }

    :deep(.van-search__content) {
        padding-left: 0 !important;
    }

    :deep(.van-tab--active) {
        font-weight: 400 !important;
    }

    :deep(.van-field__control) {
        font-size: 28px !important;
    }
</style>
